import { axInst } from "../Login/Service.jsx";

//region
export const fetchRegion = async () => {
  const { data } = await axInst.post("/lead-source/filter", {
    region: [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    DAM_Name: [],
    NEW_REGION: [],
    CUSTOMER_TYPE: [],
  });

  const regionsArray = data?.filter_data.REGION.buckets.map((e) => e.key);
  const sortedRegionArray = regionsArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedRegionArray;
};

//state
export const fetchStates = async (pRegion) => {
  const { data } = await axInst.post("lead-source/filter", {
    region: pRegion || [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    DAM_Name: [],
    NEW_REGION: [],
    CUSTOMER_TYPE: [],
  });
  const statesArray = data?.filter_data.STATE.buckets.map((e) => e.key);
  const sortedStatesArray = statesArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedStatesArray;
};

//stateoffice
export const fetchStatesOffice = async (pRegion, pState) => {
  const { data } = await axInst.post("lead-source/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    DAM_Name: [],
    NEW_REGION: [],
    CUSTOMER_TYPE: [],
  });
  const statesOfficeArray = data?.filter_data.STATE_OFFICE.buckets.map(
    (e) => e.key
  );
  const sortedStatesOfficeArray = statesOfficeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedStatesOfficeArray;
};

//DealerName
export const fetchDealer = async (pRegion, pState, pStateOffice) => {
  const { data } = await axInst.post("lead-source/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    DAM_Name: [],
    NEW_REGION: [],
    CUSTOMER_TYPE: [],
  });
  const DealerArray = data?.filter_data.DEALER_NAME.buckets.map((e) => e.key);
  const sortedDealerArray = DealerArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedDealerArray;
};

//DealerCode
export const fetchDealercode = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer
) => {
  const { data } = await axInst.post("lead-source/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    DAM_Name: [],
    NEW_REGION: [],
    CUSTOMER_TYPE: [],
  });
  const dealercodeArray = data?.filter_data.DEALER_CODE.buckets.map(
    (e) => e.key
  );
  const sorteddealercodeArray = dealercodeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sorteddealercodeArray;
};

export const fetchProductLine = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode
) => {
  const { data } = await axInst.post("lead-source/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: [],
    lob: [],
    ppl: [],
    pl: [],
    DAM_Name: [],
    NEW_REGION: [],
    CUSTOMER_TYPE: [],
  });
  const productLineArray = data?.filter_data.PRODUCT_LINE.buckets.map(
    (e) => e.key
  );

  const sortedProductLineArray = productLineArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedProductLineArray;
};

//Lob
export const fetchLOB = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pProductLine
) => {
  const { data } = await axInst.post("lead-source/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: pProductLine || [],
    lob: [],
    ppl: [],
    pl: [],
    DAM_Name: [],
    NEW_REGION: [],
    CUSTOMER_TYPE: [],
  });

  const lobArray = data?.filter_data.LOB.buckets.map((e) => e.key);
  const sortedLobArray = lobArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedLobArray;
};

//ppl
export const fetchPPL = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pProductLine,
  pLob
) => {
  const { data } = await axInst.post("lead-source/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: [],
    pl: [],
    DAM_Name: [],
    NEW_REGION: [],
    CUSTOMER_TYPE: [],
  });
  const pplArray = data?.filter_data.PPL.buckets.map((e) => e.key);
  const sortedPPLArray = pplArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedPPLArray;
};

//pl
export const fetchPL = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pProductLine,
  pLob,
  pPpl
) => {
  const { data } = await axInst.post("lead-source/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: pPpl || [],
    pl: [],
    DAM_Name: [],
    NEW_REGION: [],
    CUSTOMER_TYPE: [],
  });
  const plArray = data?.filter_data.PL.buckets.map((e) => e.key);
  const sortedPLArray = plArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedPLArray;
};

export const fetchDAM = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pProductLine,
  pLob,
  pPpl,
  pPl
) => {
  const { data } = await axInst.post("lead-source/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: pPpl || [],
    pl: pPl || [],
    DAM_Name: [],
    NEW_REGION: [],
    CUSTOMER_TYPE: [],
  });
  const damArray = data?.filter_data.DAM_Name.buckets
    .map((e) => e.key)
    .filter((e) => e !== "");
  const sortedDamArray = damArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedDamArray;
};
export const fetchNewROthers = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pProductLine,
  pLob,
  pPpl,
  pPl,
  pDam
) => {
  const { data } = await axInst.post("lead-source/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: pPpl || [],
    pl: pPl || [],
    DAM_Name: pDam || [],
    NEW_REGION: [],
    CUSTOMER_TYPE: [],
  });
  const newRArray = data?.filter_data.NEW_REGION.buckets
    .map((e) => e.key)
    .filter((e) => e !== "");
  const sortedNewRArray = newRArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedNewRArray;
};
export const fetchCustomerType = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pProductLine,
  pLob,
  pPpl,
  pPl,
  pDam,
  pNewR
) => {
  const { data } = await axInst.post("lead-source/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    ppl: pPpl || [],
    pl: pPl || [],
    dam: pDam || [],
    NEW_REGION: pNewR || [],
    CUSTOMER_TYPE: [],
  });
  const customerArray = data?.filter_data.CUSTOMER_TYPE.buckets
    .map((e) => e.key)
    .filter((e) => e !== "");
  const sortedCustomerArray = customerArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedCustomerArray;
};
